"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartPlasticsPartPrismaSchema = void 0;
const zod_1 = require("zod");
const InputJsonValue_1 = require("../inputTypeSchemas/InputJsonValue");
const DataSourceSchema_1 = require("../inputTypeSchemas/DataSourceSchema");
const ArticleSpecSchema_1 = require("../inputTypeSchemas/ArticleSpecSchema");
const ArticleTypeSchema_1 = require("../inputTypeSchemas/ArticleTypeSchema");
const SmartPlasticsTypeSchema_1 = require("../inputTypeSchemas/SmartPlasticsTypeSchema");
/////////////////////////////////////////
// SMART PLASTICS PART PRISMA SCHEMA
/////////////////////////////////////////
exports.SmartPlasticsPartPrismaSchema = zod_1.z.object({
    DataSource: DataSourceSchema_1.DataSourceSchema,
    ArticleSpecs: ArticleSpecSchema_1.ArticleSpecSchema.array(),
    ArticleType: ArticleTypeSchema_1.ArticleTypeSchema,
    smartPlasticsType: SmartPlasticsTypeSchema_1.SmartPlasticsTypeSchema.array(),
    AkeneoSku: zod_1.z.string(),
    AkeneoUuid: zod_1.z.string().nullish(),
    DiscontinuedModel: zod_1.z.boolean(),
    EchainId: zod_1.z.string(),
    ArtNr: InputJsonValue_1.InputJsonValue,
    ArtNrDE: zod_1.z.string().nullish(),
    ArtNrUS: zod_1.z.string().nullish(),
    Bezeichnung: InputJsonValue_1.InputJsonValue,
    weight: InputJsonValue_1.InputJsonValue,
    partsReferences: InputJsonValue_1.InputJsonValue.array(),
    smartPlasticsCableId: zod_1.z.string().nullish(),
    smartPlasticsParentEchainId: zod_1.z.string().nullish(),
    FreigabeECF: zod_1.z.boolean(),
    FreigabeEIC: zod_1.z.boolean(),
    FreigabeEIQ: zod_1.z.boolean(),
    FreigabeEKE: zod_1.z.boolean(),
});
exports.default = exports.SmartPlasticsPartPrismaSchema;
//# sourceMappingURL=SmartPlasticsPartPrismaSchema.js.map